import { DAYS } from './constants';
import { freqForDay, localDateStr } from './utils';

// Share of a compound's scheduled days (start..end, inclusive, local calendar days) on which at
// least one dose was logged. Same per-day rule as calcStreak: each day is judged against the
// schedule in effect THAT day via freqForDay, so past schedule edits, cycle breaks, and days
// before a brand-new item existed are all handled without re-deriving any of it here.
// `pct` is null (not 0 or NaN) when nothing was scheduled in the range.
//
// Legacy items (no freqHistory — created before that field existed and never edited since) have no
// record of when they began, so freqForDay applies today's schedule to EVERY past day, including
// months before the user started logging. Counting those would badly understate adherence, so a
// legacy item is only judged from its first logged dose onward (none logged = nothing to judge).
// Items with freqHistory know their own start, so they are not clamped.
export function calcAdherence({ compound, compoundKey, shots, start, end }) {
  const loggedDays = new Set(
    shots.filter(s => s.compound === compoundKey).map(s => localDateStr(new Date(s.date)))
  );
  const legacy = !Array.isArray(compound.freqHistory) || compound.freqHistory.length === 0;
  const firstLoggedDay = legacy ? [...loggedDays].sort()[0] : null;
  if (legacy && !firstLoggedDay) return { scheduled: 0, logged: 0, pct: null };
  const last = new Date(end.getFullYear(), end.getMonth(), end.getDate());
  let scheduled = 0, logged = 0;
  for (let day = new Date(start.getFullYear(), start.getMonth(), start.getDate()); day <= last; day = new Date(day.getFullYear(), day.getMonth(), day.getDate() + 1)) {
    const dayStr = localDateStr(day);
    if (firstLoggedDay && dayStr < firstLoggedDay) continue;
    if (!(freqForDay(compound, dayStr) || []).includes(DAYS[day.getDay()])) continue;
    scheduled++;
    if (loggedDays.has(dayStr)) logged++;
  }
  return { scheduled, logged, pct: scheduled > 0 ? Math.round((logged / scheduled) * 100) : null };
}
